import { Button, Divider, InputNumber, message, Modal, Typography } from "antd";
import {
  convertIntoDashUSFormat,
  formatTimeStamp,
} from "utilities/dateUtility";
import { displayDollar } from "utilities/tableUtility";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars-2";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import { useRef, useState } from "react";
import { isEmpty } from "lodash";
import CommissionPlan from "../../../../../redux/models/commissionPlan";

const { Paragraph, Title } = Typography;

export const CommissionApprovalDetailsModal = ({
  data,
  history,
  onCancel,
  onAmountEdited,
}) => {
  const inputRef = useRef(null);
  const [isEdit, setIsEdit] = useState(false);

  const editAmount = async () => {
    const newValue = +inputRef.current.value;

    const payload = {
      commissionApprovalId: data.id,
      duplicateAmount: newValue,
      currency: "USD",
    };

    try {
      await CommissionPlan.editCommissionApproval(payload);
      setIsEdit(false);
      onAmountEdited?.(newValue);
    } catch (err) {
      message.error("Failed to edit amount.");
      console.error(err);
    }
  };

  return (
    <Modal
      centered
      width={572}
      className="clientBillingModal modal-overflow-auto"
      title={data?.submittedJobBill.client.name}
      footer={false}
      open
      onCancel={onCancel}
    >
      <>
        <span className="clientBillingType">
          {data?.submittedJobBill.billingTypeName}
        </span>
        <div className="clientBillingWrap">
          <div className="clientBillingTitle">
            <div className="clientBilling">
              <Title level={4}>ID:</Title>
              <Paragraph>{data?.id}</Paragraph>
            </div>
            <div className="clientBilling">
              <Title level={4}>Candidate Name:</Title>
              <Paragraph>{data?.submittedJobBill.candidateName}</Paragraph>
            </div>
            <div className="clientBilling">
              <Title level={4}>Job Title:</Title>
              <Paragraph>{data?.submittedJobBill.jobTitle}</Paragraph>
            </div>
            <div className="clientBilling">
              <Title level={4}>Create Date:</Title>
              <Paragraph>
                {convertIntoDashUSFormat(data?.createdAt, false)}
              </Paragraph>
            </div>
            <div className="clientBilling">
              <Title level={4}>Original Commision Earned:</Title>
              <Paragraph>
                {[displayDollar(+data?.amount.toFixed(2)), `(USD)`].join(" ")}
              </Paragraph>
            </div>
            <div className="clientBilling billed-amount">
              {isEdit ? (
                <div className="billingField">
                  <Title level={4} className="orignalAmount">
                    Billed Commission Earned:
                  </Title>
                  <InputNumber
                    ref={inputRef}
                    defaultValue={data?.duplicateAmount}
                  />
                  <Button
                    type="link"
                    onClick={() => setIsEdit(false)}
                    icon={<CloseCircleOutlined />}
                  />
                  <Button
                    type="link"
                    onClick={editAmount}
                    icon={<CheckCircleOutlined />}
                  />
                </div>
              ) : (
                <div>
                  <Title level={4} className="orignalAmount">
                    Billed Commission Earned:{" "}
                    <span className="cbOrignalAmount">
                      {[displayDollar(+data?.duplicateAmount), `(USD)`].join(
                        " ",
                      )}
                      <Button
                        type="link"
                        onClick={() => setIsEdit(true)}
                        disabled={(data?.amount ?? 0) < 0}
                        icon={<i className="icon-edit" />}
                      />
                    </span>
                  </Title>
                </div>
              )}
            </div>
          </div>
        </div>
        <Divider className="divider" />
        <Title level={5} className="clientHistoryTitle">
          History
        </Title>
        <div className="clientHistoryWrap">
          <Scrollbars style={{ height: 460 }}>
            {!isEmpty(history) ? (
              history.map((item) => (
                <div key={item.id} className="clientHistoryDetail">
                  <div className="clientAmountHistory">
                    <div className="clientName">
                      <Title level={5}>
                        {item.edit ? "Edited " : "Converted "} By:
                      </Title>
                      <Paragraph>{item.user.name}</Paragraph>
                    </div>
                    <div className="clientDate">
                      <Title level={5}>Converted Date:</Title>
                      <Paragraph>
                        {formatTimeStamp(item.createdAt ?? "N/A")}
                      </Paragraph>
                    </div>
                  </div>
                  <Divider className="historyDivider" />
                  <div className="clientAmount">
                    <Title level={5}>
                      Billed Amount:{" "}
                      {`${displayDollar(
                        +item.billingAmount?.toFixed(2),
                      )} (USD)`}
                    </Title>
                    {!item.edit && (
                      <Paragraph>
                        Conversion Rate: {item.conversionRate?.toFixed(3)}
                      </Paragraph>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <EmptyPlaceholder />
            )}
          </Scrollbars>
        </div>
      </>
    </Modal>
  );
};
